/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index textarea to autogenerate all the components and extensions
 * Used by "prepareTextareas"
 */

import Textarea from './textarea/Textarea'
export * from './textarea/Textarea'
export default Textarea
